import { JOBS_LIST_URL_KEY } from './constants';

export const rememberJobsListUrl = (url: string) => {
  try {
    sessionStorage.setItem(JOBS_LIST_URL_KEY, url);
  } catch {
    return;
  }
};

export const getJobsListUrl = (fallback: string) => {
  try {
    return sessionStorage.getItem(JOBS_LIST_URL_KEY) || fallback;
  } catch {
    return fallback;
  }
};
